// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bhqg","icon":"styles_icon__333qC"};